export const APP_TITLE = 'HOAONE';
export const APP_SUBTITLE = 'One Platform for Every Community';
